import { Injectable } from '@angular/core';
import { ITreatmentApiModel } from '@app/shared/models';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CustomerStopIntentService {
  private openCustomerStopDialogIntentSource = new Subject<ITreatmentApiModel[]>();
  public openCustomerStopDialogIntent$ = this.openCustomerStopDialogIntentSource.asObservable();

  public emitOpenCustomerStopDialongIntentEvent$(treatments: ITreatmentApiModel[]): void {
    this.openCustomerStopDialogIntentSource.next(treatments);
  }
}
